var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H2V0h2v4zm5 3h2v4H9V7zM4 7v2H0V7h4zm5-3V2h4v2H9zM2 2v2H0V2h2zm9 7V7h2v2h-2zM2 9h2v2H2V9zm9-7H9V0h2v2z"
  })));
}
export default SvgExitFullscreen;